// extracted by css-extract-rspack-plugin
export default {"cancel":"cancel-zXBDwt"};